import { useState, useEffect, useCallback } from 'react'

// Custom hook này dùng để cancel các request thừa: Ví dụ như rời khỏi một trang
const useCancelRequest = () => {
  const [controller] = useState(new AbortController())

  useEffect(() => {
    // khi unmounted -> Huỷ yêu cầu
    return () => {
      controller.abort()
    }
  }, [controller])

  const cancelRequest = useCallback(() => {
    controller.abort()
  }, [controller])

  return {
    controller,
    cancelRequest,
  }
}

export default useCancelRequest
